<button nz-button (click)="goBackToQuote()"><nz-icon nzType="left" nzTheme="outline" />Back To Quote</button>
<app-pdf-viewer [pdfUrl]="safePdfUrl"></app-pdf-viewer>
